export default __webpack_public_path__ + "static/media/luzverde_logo.e35a65ef.png";